import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Select, Tag, Tooltip } from "antd";
import { useCallback } from "react";
import { EUserRole, TRANSLATABLE_METADATA_TEMPLATE_ATTRIBUTES_LIST, TemplateMetaDataField, getTemplateHeadline } from "@devowl-wp/api-real-cookie-banner";
import { useTranslation } from "../../../../../others/i18n.js";
import { getFieldNameTranslated } from "../../../../../util/template/translation.js";
import { FormFieldVisibilityWrapper } from "../formFieldVisibilityWrapper.js";
function FormFieldTemplateSuccessorOfTemplate(options) {
    const { t } = useTranslation();
    const { activeTemplates, deletedTemplates, hiddenIdentifier } = options;
    const tagRender = useCallback((props)=>{
        const { label, value, closable, onClose } = props;
        const onPreventMouseDown = (event)=>{
            event.preventDefault();
            event.stopPropagation();
        };
        let color = undefined;
        const match = deletedTemplates?.find((template)=>template.identifier === value);
        if (match) {
            color = "red";
        }
        return /*#__PURE__*/ _jsx(Tooltip, {
            title: color ? t("Deleted template") : t("Active template"),
            children: /*#__PURE__*/ _jsx(Tag, {
                color: color,
                onMouseDown: onPreventMouseDown,
                closable: closable,
                onClose: onClose,
                style: {
                    marginRight: 3
                },
                children: label
            })
        });
    }, [
        deletedTemplates
    ]);
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
        fieldNames: TemplateMetaDataField.SuccessorOfIdentifier,
        permissionCheck: {
            whenRole: EUserRole.Translator,
            roleWhiteList: TRANSLATABLE_METADATA_TEMPLATE_ATTRIBUTES_LIST
        },
        children: /*#__PURE__*/ _jsx(Form.Item, {
            label: getFieldNameTranslated(TemplateMetaDataField.SuccessorOfIdentifier, t),
            name: TemplateMetaDataField.SuccessorOfIdentifier,
            children: /*#__PURE__*/ _jsx(Select, {
                allowClear: true,
                showSearch: true,
                mode: "multiple",
                style: {
                    width: "100%"
                },
                placeholder: t("Select template(s)"),
                optionFilterProp: "label",
                options: [
                    {
                        label: t("Deleted"),
                        options: deletedTemplates?.filter((template)=>!hiddenIdentifier.includes(template.identifier))?.map((template)=>{
                            return {
                                label: getTemplateHeadline(template),
                                value: template.identifier
                            };
                        }).sort((a, b)=>a.label.localeCompare(b.label)) || []
                    },
                    {
                        label: t("Active"),
                        options: activeTemplates?.filter((template)=>!hiddenIdentifier.includes(template.identifier))?.map((template)=>{
                            return {
                                label: getTemplateHeadline(template),
                                value: template.identifier
                            };
                        }).sort((a, b)=>a.label.localeCompare(b.label)) || []
                    }
                ],
                tagRender: tagRender
            })
        })
    });
}
export { FormFieldTemplateSuccessorOfTemplate };
